import { connect } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { HeaderComponent } from './HeaderComponent'
import { priceSelector } from 'shared/store/ecommerce/order'
import { Dispatch } from 'redux'
import { goBack, push } from 'connected-react-router'
import { displayCollectModeSubtitle } from 'shared/utils/ecommerce/utils'
import { untransformPoints } from 'shared/store/kingdom/points'

const mapStateToProps = (state: RootState) => {
    const { restaurant, collectMode, pickUpInfo } = state.ecommerceOrderState
    const { finalPrice } = priceSelector(state)
    const { promotion } = state.router.location.state || {}
    return {
        restaurant,
        collectModeText: collectMode && displayCollectModeSubtitle(collectMode),
        collectMode,
        totalPrice: finalPrice,
        promotion,
        pickUpInfo
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    navigate: (to: string) => d(push(to)),
    goBack: () => d(goBack()),
    untransformPoints: (couponCode: string) => d(untransformPoints(couponCode))
})

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)

export { Header }
